"use client";
'use strict';

var React = require('react');
var useLocation = require('./useLocation.js');

function parseSearch(search) {
    const urlSearchParams = new URLSearchParams(search);
    // @ts-ignore
    return Object.fromEntries(urlSearchParams.entries());
}
/**
 * React hook for query params
 *
 * @example
 * ```javascript
 * const [params, setParams] = useQueryParams()
 * ```
 */
function useQueryParams() {
    const { replace, search } = useLocation.useLocation();
    const [params, setParams] = React.useState(parseSearch(search));
    const set = (params) => {
        // @ts-ignore
        const stringParams = new URLSearchParams(params).toString();
        replace(`?${stringParams}`);
    };
    React.useEffect(() => {
        setParams(parseSearch(search));
    }, [search]);
    return [params, set];
}

exports.useQueryParams = useQueryParams;
//# sourceMappingURL=useQueryParams.js.map
